import { TabRootStack } from '@/components/TabRootStack';

export default TabRootStack;
